
import { Note } from '@/@types/responses/note/Note'
import { defineComponent } from 'vue'
import DotsSvg from '@/components/svgs/DotsSvg.vue'

export default defineComponent({
  name: 'NoteTile',
  components: {
    DotsSvg
  },
  props: {
    note: {
      type: Note,
      required: true
    }
  },
  emits: ['delete', 'edit'],
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    closeMenu(): void {
      this.showMenu = false
    },
    onDeleteNoteClicked(): void {
      this.closeMenu()
      this.$emit('delete', this.note)
    },
    onDotsClicked(): void {
      this.showMenu = true
    },
    onEditNoteClicked(): void {
      this.closeMenu()
      this.$emit('edit', this.note)
    }
  }
})
